/**

Coded by www.techhighway.ca

*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

import { useLocation, useNavigate } from "react-router-dom";
import authPermission from "utility/auth-permissions";

const loggedUserId = localStorage.getItem("user_id");

function DataTableBodyCell({ noBorder=false, borderTop=false, align="left", children, ...props }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission } = authPermission();
  const pagePermission = hasPermission(location.pathname);
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={props?.vertical_row_padding ? props?.vertical_row_padding : 1.5}
      px={props.header ? props?.horizontal_row_padding : 0}
      onDoubleClick={() => {
        if (
          pagePermission.edit &&
          props?.id &&
          props?.doubleclickflag == "true" &&
          props?.header != "actions" &&
          props?.header != "Actions"
        ) {
          if (
            (location.pathname == "/user-management" && loggedUserId != props?.id) ||
            location.pathname != "/user-management"
          ) {
            navigate(`${location.pathname}/edit?id=${props?.id}`);
          }
        }
      }}
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.sm,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
        borderTop: borderTop ? `${borderWidth[2]} solid ${light.main}` : "none",
      })}
      {...props}
    >
      <MDBox display="inline-block" width="100%" color="text" sx={{ verticalAlign: "middle" }}>
        {children}
      </MDBox>
    </MDBox>
  );
}

// // Setting default values for the props of DataTableBodyCell
// DataTableBodyCell.defaultProps = {
//   noBorder: false,
//   borderTop: false,
//   align: "left",
// };

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  borderTop: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableBodyCell;
